export const CUE_SHEET_STATUS_LABELS = {
    in_progress: 'In lavorazione',
    approved: 'Approvato',
    to_review: 'Da rivedere',
    to_assign: 'Da assegnare',
    assigned: 'Assegnato',
    unassigned: 'Non assegnato',
};

export const getCueSheetStatusLabel = (status) =>
    CUE_SHEET_STATUS_LABELS[status] ?? status;
